import { render, staticRenderFns } from "./icon-chevron.vue?vue&type=template&id=52124055&scoped=true&"
import script from "./icon-chevron.vue?vue&type=script&lang=js&"
export * from "./icon-chevron.vue?vue&type=script&lang=js&"
import style0 from "./icon-chevron.vue?vue&type=style&index=0&id=52124055&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52124055",
  null
  
)

export default component.exports